import React, { useEffect, useState } from "react";
import request from "axios";
import moment from "moment";
import LoadingMessage from "../loadingMessage";
import ReferencesForm from "./referencesForm";

const References = props => {
  const [name, setName] = useState("");
  const [niNumber, setNiNumber] = useState("");
  const [responsibleTeam, setResponsibleTeam] = useState("");
  const [consentDate, setConsentDate] = useState("");
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(null);
  const [formState, setFormState] = useState(null);

  const Messages = Object.freeze({
    ERROR_WRONG_URL:
      "This URL is invalid. Please check the provided URL address and try again",
    ERROR_UNKNOWN: "There was an unknown application error. Please try again.",
    SUCCESS: "Your reference was saved. Thank you."
  });

  const { token } = props.match.params;

  const setData = data => {
    setName(data.name);
    setNiNumber(data.niNumber);
    if (data.consentDate) {
      setConsentDate(`${moment(data.consentDate).format("Do MMMM YYYY")}`);
    }
    setResponsibleTeam(data.responsibleTeam);
  };

  const handleError = (error, data) => {
    if (error.response && error.response.status === 400) {
      setMessage(Messages.ERROR_WRONG_URL);
    } else {
      setMessage(Messages.ERROR_UNKNOWN);
      if (data) {
        setFormState(data.reference);
      }
    }
    setLoading(false);
  };

  const displayForm = () => !loading && name && message !== Messages.SUCCESS;

  const saveReference = data => {
    setLoading(true);
    return request
      .post(
        `${process.env.REACT_APP_PROFILE_API_URL}/clientDashboard/candidate/${token}/reference`,
        data
      )
      .then(() => setLoading(false))
      .then(() => setMessage(Messages.SUCCESS))
      .then(() => setFormState(null))
      .catch(err => handleError(err, data));
  };

  useEffect(() => {
    request
      .get(
        `${process.env.REACT_APP_PROFILE_API_URL}/clientDashboard/candidate/${token}`,
        {}
      )
      .then(({ data }) => setData(data))
      .then(() => setLoading(false))
      .catch(err => handleError(err));
  }, []);

  const ReferenceHeader = () => (
    <div className="text-center border mb-2">
      <h4>Reference Request</h4>
      <p>
        HR GO Recruitment has authority to request a reference(s) on behalf of
        the employee. If you are not the intended recipient you must not read,
        copy, distribute or disseminate this communication to anyone other than
        the addressee or use the information it contains. The information you
        provide may be shared with other prospective employers and with the
        employee. If you have any questions, please contact the HR GO consultant
        who emailed you this reference request. Thank you for your time.
      </p>
      <p>
        We take the safeguarding of learners, educators and learning
        environments very seriously. In line with Safer Recruitment guidelines
        we have a robust process, part of which is the need for authentic,
        verifiable and specific references. These references are used in
        conjunction with other Safer Recruitment practices to determine the
        suitability for work of the applicant. If you have a concern or question
        that you would like to discuss prior to completing this form, please
        call 01634 560 452.
      </p>
    </div>
  );

  const ReferenceConsent = () => (
    <div
      className={displayForm() ? "text-center border mb-2 bg-white" : "d-none"}
    >
      <h4>Consent</h4>
      <p>This person consented to us requesting references:</p>
      <p>
        {name} {consentDate}
      </p>
      <p className="signature">{name}</p>
    </div>
  );

  const ReferencesFormWrapper = () => (
    <div className="mb-2">
      {displayForm() && (
        <ReferencesForm
          name={name}
          niNumber={niNumber}
          responsibleTeam={responsibleTeam}
          saveReference={saveReference}
          initialState={formState}
        />
      )}
    </div>
  );

  const LoadingComponent = () => (
    <div
      style={{ position: "relative", width: "100%", height: "100%" }}
      className={loading ? "" : "d-none"}
    >
      <LoadingMessage />
    </div>
  );

  const MessageComponent = () => (
    <div className={message ? "d-block text-center" : "d-none"}>
      <div
        className={
          message === Messages.SUCCESS ? "successMessage" : "errorMessage"
        }
      >
        {message}
      </div>
    </div>
  );

  const DisplayStatusComponent = () => (
    <div className={"mb-2"}>
      <LoadingComponent />
      <MessageComponent />
    </div>
  );

  const ReferencesWrapper = () => (
    <div className="pt-3">
      <ReferenceHeader />
      <DisplayStatusComponent />
      <ReferenceConsent />
      <ReferencesFormWrapper />
    </div>
  );

  return <ReferencesWrapper />;
};

export default References;
